import { queryUnitAccountList, syncUnitAccount } from '../services/index';

export default {
  namespace: 'accountBalancesChecking',
  state: {},
  effects: {
    /**
     * 单位账户列表查询
     */
    *queryUnitAccountList({ payload }, { call }) {
      const result = yield call(queryUnitAccountList, payload);
      return result;
    },
    /**
     * 单位账户同步
     */
    *syncUnitAccount({ payload }, { call }) {
      const result = yield call(syncUnitAccount, payload);
      return result;
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
